import { useMutation } from '@tanstack/react-query';
import { GET, GET_CUSTOMER_LINE } from '../../services';
import { ROUTES_PATH } from '../../resources/routes-name';
import { navigateTo } from '../../utils/navigation';

export const useGetCustomer = () => {
  return useMutation({
    mutationFn: async ({ userId }) => {
      const response = await GET(GET_CUSTOMER_LINE(userId));
      return response;
    },
    onError: () => {
      setTimeout(() => {
        navigateTo({
          pathname: ROUTES_PATH.ROUTE_ENTERTEL.PATH,
        });
      }, 1500);
    },
  });
};
